/**
 * Helpers and types
 */
import {pure} from '@react/store'
import {DefaultComponentProps} from '@interface/common'


/**
 * Organizations Screen
 */
export default pure(({user, store, modal}: DefaultComponentProps) => {

  return (
    <div id="dashboard">
      <header>
        <div className="left">
          <h3 className="margin-0">Dashboard</h3>
        </div>
      </header>
    </div>
  )
})